import { atom } from "recoil";

export const adverState = atom<boolean>({
  key: "adverState",
  default: true,
});
